import React, { useContext, useEffect } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import profile from'./Assets/Purple_Abstract_A_Letter_Free_Logo-removebg-preview.png'
import 'aos/dist/aos.css'; // Import AOS styles
import AOS from 'aos'; // Import AOS library
import { addcontext } from '../ContextShare/ContextShare';
function SideArea() {
    const {NavSelected,setNavSelected}=useContext(addcontext)
    const {ContactOpened,setContactOpened}=useContext(addcontext)
    useEffect(() => {
        AOS.init({
          duration: 1000, // Animation duration in milliseconds
          once: true, // Whether animation should happen only once while scrolling down
        });
      }, []);
    return (
        <div
            className="flex md:flex-col flex-row justify-start items-center w-full h-full "     
            style={{ fontFamily: "Ropa Sans" }}
        >
            <div data-aos="zoom-in" className='md:w-48 w-28 md:h-10 absolute md:top-5 z-40 top-auto md:bottom-auto bottom-48 md:right-2 right-[50%] md:left-auto left-[50%] pointer-events-auto md:flex hidden'>
                {!ContactOpened&&<button onClick={()=>setContactOpened(true)} className='px-10 py-1 rounded-lg border bg-gray-200 border-gray-400 hover:bg-gray-200 hover:text-blue-700 text-gray-900 font-bold flex flex-row md:gap-2 gap-1 md:text-sm text-xs items-center' ><span>Contact me</span><Icon icon="lucide:move-right" /></button>}
            </div>

            <div data-aos="zoom-in" className='md:flex hidden absolute top-5 md:left-8 left-[50%] md:right-auto right-[50%] pointer-events-auto'>
                <span className='text-white text-xl font-extrabold flex flex-row items-center ' style={{ fontFamily: 'Roboto Mono' }}><Icon icon="token:aart" /><span>DIL</span></span>
            </div>

            <div className="flex w-full justify-center items-center">
                <div className="flex md:flex-col flex-row md:items-start items-center justify-evenly gap-2 w-full ">

                    <div data-aos="zoom-in" className="md:flex hidden invisible md:justify-start justify-start md:w-28 w-12 md:h-28 h-10 rounded-full overflow-hidden md:ms-5 md:mb-20">
                        <img
                            src={profile}
                            className="h-full w-full object-cover"
                            alt="User Avatar"
                        />
                    </div>
                    {/* <MenuItem icon="fluent:home-more-32-regular"  label="Home" /> */}
                    <MenuItem icon="iconamoon:profile-bold" label="About me" />
                    <MenuItem icon="iconoir:laptop-dev-mode" label="Projects" />
                    <MenuItem icon="mdi:briefcase-outline" label="Experience" />
                    <MenuItem icon="ri:blogger-line" label="Blogs" />
                    <MenuItem icon="mdi:folder-key-network-outline" label="Public key" />
                    <MenuItem icon="pepicons-pencil:cv" label="CV" />

                    <div className='md:ms-5 md:relative md:bottom-auto bottom-44 absolute flex flex-row gap-2 mt-5 pointer-events-auto' data-aos="zoom-in">
                    <a className='w-10 h-10 rounded flex items-center justify-center text-gray-400 hover:scale-125' href='https://www.linkedin.com/in/adil-k-k/' target='_blank'><Icon icon="mdi:linkedin" className='text-4xl' /></a>
                    <a className='w-10 h-10 rounded flex items-center justify-center text-gray-400 hover:scale-125 ' href='https://github.com/aadheil' target='_blank'><Icon icon="mdi:github" className='text-4xl' /></a>
                    <a className='w-10 h-10 rounded flex items-center justify-center text-gray-400 hover:scale-125' href='https://www.instagram.com/aadheil?igsh=Nnh1eXlweW54NG84' target='_blank'><Icon icon="mdi:instagram" className='text-4xl' /></a>
                    </div>

                    <div data-aos="zoom-in" className='md:w-48 w-40 md:h-10 md:ms-5 md:relative md:bottom-auto bottom-32 absolute flex flex-row gap-2 mt-5 pointer-events-auto md:hidden'>
                <button onClick={()=>setContactOpened(true)} className='px-10 py-1 rounded-lg border bg-gray-200 border-gray-400 hover:bg-gray-200 hover:text-blue-700 text-gray-900 font-bold flex flex-row md:gap-2 gap-1 md:text-sm text-xs items-center'><span>Contact me</span><Icon icon="lucide:move-right" /></button>
            </div>

                </div>
                
            </div>
        </div>
    );
}

function MenuItem({ icon, label }) {
    const {NavSelected,setNavSelected}=useContext(addcontext)
    return (
        <div onClick={()=>setNavSelected(label)} data-aos="zoom-in" className="md:mt-0 mt-1 pointer-events-auto text-gray-400 hover:text-blue-300 md:ms-5 px-2 flex text-center justify-start items-center gap-3 md:w-36 w-22 rounded py-1  transition duration-300 ease-in-out cursor-pointer hover:shadow-md hover:border-b-2 hover:border-blue-500 border-b-2 border-transparent ">
            <Icon icon={icon} className="font-bold text-2xl md:flex hidden" />
            <h5 className=" md:text-lg text-xs ">{label}</h5>
        </div>
    );
}

export default SideArea;
